<p-autoComplete #cujAutocomplete [(ngModel)]="value" [suggestions]="cujs" appendTo="body"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [inputId]="id"
                (completeMethod)="findUjs($event)" [minLength]="7" [disabled]="disabled">
</p-autoComplete>
